export  default {
  layout:{

  },
  systemName:"GFT manage system",
  global: {
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    confirm: 'Confirm',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    open: 'Open',
    enabled: 'Enabled',
    disabled: 'Disabled',
    delete: 'Delete',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    deploy: 'Deploy',
    refresh: 'Refresh',
    close: 'Close',
    closeOther: 'Close Other',
    closeAll: 'Close All',
    tip: 'Tip',
    handle: 'Handle',
    success: 'Success',
    save: 'Save',
    saveAndContinue: 'Save And Continue',
    sort: 'Sort',
    prevPage: 'Prev',
    nextPage: 'Next'
  },

}
